import { canvasPanelClassNames } from "../canvasTheme";
import type { SettingsPanelProps } from "../settingsPanelTypes";

type ShortcutsSettingsPageProps = Pick<
  SettingsPanelProps,
  "shortcutOptions" | "keyboardShortcuts" | "onKeyboardShortcutChange"
>;

export function ShortcutsSettingsPage({
  shortcutOptions,
  keyboardShortcuts,
  onKeyboardShortcutChange,
}: ShortcutsSettingsPageProps) {
  return (
    <div className={canvasPanelClassNames.section}>
      <h4 className={canvasPanelClassNames.sectionTitle}>Scorciatoie tastiera</h4>
      <div className="mt-2 grid grid-cols-[1fr_150px] gap-2">
        {shortcutOptions.map((option) => (
          <label key={option.command} className="contents text-[11px] font-medium text-[#4b3e27]">
            <span className="flex items-center rounded-md bg-white px-2 py-1 text-[11px] text-[#1f2937]">
              {option.label}
            </span>
            <input
              className="w-[150px] max-w-full rounded-md border border-[rgba(74,58,31,0.18)] bg-white px-2 py-1 text-center text-[12px] font-semibold text-[#1f2937]"
              type="text"
              value={keyboardShortcuts[option.command] ?? ""}
              placeholder="-"
              onChange={(event) => onKeyboardShortcutChange(option.command, event.target.value)}
            />
          </label>
        ))}
      </div>
      <p className={`m-0 mt-2 ${canvasPanelClassNames.mutedText}`}>
        Usa combinazioni come R, Shift+R, Ctrl+M. Lascia vuoto per disattivare.
      </p>
    </div>
  );
}
